/* Coastal Slate & Brass — scroll reveal.
   The .reveal elements are only hidden when the `tco-anim` class is present on
   <html>, which an inline snippet in theme.liquid adds before first paint. If
   JavaScript is unavailable or fails, that class is never added and every
   .reveal element renders at full opacity — content is never lost to a
   broken animation. */
(function () {
  if (!document.documentElement.classList.contains('tco-anim')) return;

  var targets = document.querySelectorAll('.tco .reveal:not(.in)');
  if (!targets.length) return;

  if (!('IntersectionObserver' in window)) {
    targets.forEach(function (el) { el.classList.add('in'); });
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12 }
  );

  targets.forEach(function (el) { io.observe(el); });

  // Theme-editor re-renders replace section markup; re-scan so new nodes reveal.
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.tco .reveal:not(.in)').forEach(function (el) {
      io.observe(el);
    });
  });
})();
